export default function( selector, preventScroll = false ) {
    if ( !selector ) return;

    const el = document.querySelector(selector)

    if ( !el || el === document.activeElement ) return;

    el.setAttribute('tabindex', '-1')
    el.focus({ preventScroll })
}